import Table from '../table/Table';
import React from 'react';
import DashboardModal from './DashboardModal';
import SalvPage from '../common/SalvPage';
import { useQueryDashboards } from './dashboardActions';
import { useDispatch } from 'react-redux';
import { showFeedback } from '../feedback/feedbackReducer';

export const Dashboards = () => {
  const dispatch = useDispatch();
  const { data: dashboards, isError, isPending } = useQueryDashboards();

  if (isError) {
    dispatch(
      showFeedback({
        message: 'Could not load Dashboards',
        success: false,
      })
    );
    return <div />;
  }

  return (
    <SalvPage title={'Dashboards'} actions={<DashboardModal />}>
      {!isPending && (
        <Table
          fetchPage={() => {
            return;
          }}
          total={dashboards.length}
          page={0}
          size={dashboards.length}
          items={dashboards}
          header={() => (
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Dashboard ID</th>
              <th>Hidden</th>
              <th className='text-end'>Actions</th>
            </tr>
          )}
          body={(dashboards) => {
            return dashboards.map((dashboard) => (
              <tr key={dashboard.id}>
                <td>{dashboard.id}</td>
                <td>{dashboard.name}</td>
                <td>{dashboard.dashboardId}</td>
                <td>{dashboard.hidden ? 'Yes' : 'No'}</td>
                <td className='text-end'>
                  <DashboardModal dashboard={dashboard} />
                </td>
              </tr>
            ));
          }}
        />
      )}
    </SalvPage>
  );
};

export default Dashboards;
